import VehicleReservation from '../../../../../../pages/vip/features/vehicle-reservation/return-policy/desktop';

export default VehicleReservation;
